import React from "react";
import "./Privacy.css";

export default function Privacy() {
  return (
    <div className="privacy-container">
      <h1>PRIVACY POLICY</h1>
      {/* <p><strong>Last Updated:</strong> [Date]</p> */}

      <p>
        This Privacy Policy explains how JENIZO IT TECH PVT LTD (“we”, “our”, “company”)
        collects, uses, stores, and protects your information when you visit our website,
        purchase services, or interact with our platform.
      </p>

      <p>By using our website or services, you agree to the terms of this Privacy Policy.</p>

      <hr />

      <h2>1. Information We Collect</h2>
      <h3>🔸 Personal Information</h3>
      <ul>
        <li>Name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Billing information</li>
        <li>Address (if required)</li>
      </ul>

      <h3>🔸 Technical Information</h3>
      <ul>
        <li>IP address</li>
        <li>Device details</li>
        <li>Browser information</li>
        <li>Cookies</li>
      </ul>

      <h3>🔸 Usage Information</h3>
      <ul>
        <li>Pages visited</li>
        <li>Clicks, scrolls</li>
        <li>Time spent on site</li>
      </ul>

      <h3>🔸 Service Information</h3>
      <p>If you purchase our services:</p>
      <ul>
        <li>Website/App content</li>
        <li>Project details</li>
        <li>Client documents & inputs</li>
      </ul>

      <hr />

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>Provide and deliver services</li>
        <li>Process payments</li>
        <li>Improve user experience</li>
        <li>Send updates or notifications</li>
        <li>Deliver training/internship materials</li>
        <li>Respond to customer queries</li>
        <li>Maintain platform security</li>
      </ul>
      <p><strong>We do NOT sell or rent your data to third parties.</strong></p>

      <hr />

      <h2>3. How We Protect Your Data</h2>
      <ul>
        <li>SSL encryption</li>
        <li>Secure servers</li>
        <li>Password-protected systems</li>
        <li>Restricted internal access</li>
        <li>Regular audits</li>
      </ul>
      <p>No online system is 100% secure — users must also take precautions.</p>

      <hr />

      <h2>4. Sharing of Information</h2>
      <p>We may share information only with:</p>
      <ul>
        <li>Payment gateways (Razorpay, Instamojo, etc.)</li>
        <li>Hosting & server providers</li>
        <li>Legal authorities when required</li>
      </ul>
      <p><strong>We never share data for marketing without permission.</strong></p>

      <hr />

      <h2>5. Cookies Policy</h2>
      <p>We use cookies to:</p>
      <ul>
        <li>Improve website experience</li>
        <li>Understand user behaviour</li>
        <li>Save login preferences</li>
      </ul>
      <p>Users can disable cookies anytime from browser settings.</p>

      <hr />

      <h2>6. Data Storage & Retention</h2>
      <p>We store your data securely for:</p>
      <ul>
        <li>Legal compliance</li>
        <li>Ongoing project requirements</li>
        <li>Record-keeping</li>
      </ul>
      <p>Users may request data deletion (except where legally required).</p>

      <hr />

      <h2>7. Third-Party Links</h2>
      <p>
        Our website may contain links to external websites.  
        We are not responsible for their content or policies.
      </p>

      <hr />

      <h2>8. Payments & Billing</h2>
      <p>Payments are processed securely through:</p>
      <ul>
        <li>Razorpay</li>
        <li>Instamojo</li>
        <li>UPI</li>
        <li>Bank Transfer</li>
      </ul>
      <p><strong>We do NOT store card information.</strong></p>

      <hr />

      <h2>9. Children's Privacy</h2>
      <p>Our services are not intended for users under 13 years.</p>

      <hr />

      <h2>10. User Rights</h2>
      <ul>
        <li>Access your data</li>
        <li>Request correction</li>
        <li>Request deletion</li>
        <li>Withdraw consent</li>
        <li>Request data export</li>
      </ul>
      <p>Send requests to our support email.</p>

      <hr />

      <h2>11. Changes to Privacy Policy</h2>
      <p>We may update this Policy occasionally. Continued use means acceptance.</p>

      <hr />

      <h2>12. Contact Us</h2>
      <p>
        <strong>JENIZO IT TECH PVT LTD</strong><br />
        📧 Email: info@jenizo.in<br />
        📞 Phone: +91 8179785211<br />
        📍 Hyderabad, Telangana, India
      </p>
    </div>
  );
}
